import { Component, OnInit } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-account-dialog',
  templateUrl: './account-dialog.component.html'
})
export class AccountDialogComponent implements OnInit {
  accounts: Array<any> = [];
  selectedItem: boolean = false;
  selectedAccount: any = {};

  // these are passed in when the dialog is loaded
  change: any;

  constructor(public modal: BsModalRef, private accountService: AccountService) { }

  ngOnInit() {
    this.accountService.getAccounts().subscribe(
      (result: any) => {
        this.accounts = result;
        this.autoFocus();
      },
      err => {
        // TODO: something
      }
    );
  }

  autoFocus() {
    setTimeout(() => {
      (document.querySelector('.account-select-container > .below') as any).click();
      setTimeout(() => {
        (document.querySelector('.account-select-container .filter > input') as any).focus();
      }, 350);
    }, 200);
  }

  select(item) {
    this.selectedItem = true;
    this.selectedAccount = item;
  }
}



// WEBPACK FOOTER //
// ./client/app/account-dialog/account-dialog.component.ts